import React from "react";
import "./DataAnalysis.css";
import dataPattern from "./data-pattern.png"; // Ensure correct path

const DataAnalytics = () => {
    return (
        <section className="data-analytics">
            {/* Left Div - Text Content */}
            <div className="data-text">
                <h3>Transform Your Data with Interactive Dashboards</h3>
                <p>
                    Unlock the true potential of your business by turning raw data into valuable insights. Our
                    customized data analytics services provide interactive dashboards and visualizations that
                    enable you to make data-driven decisions with ease. Whether you're tracking key metrics or
                    analyzing trends, our solutions provide you with clarity and actionable intelligence.
                </p>
                <p>
                    With our advanced analytics tools, you can monitor performance in real-time, explore data 
                    from multiple angles, and uncover hidden patterns. Empower your team with the insights they 
                    need to drive growth and innovation.
                </p>
            </div>

            {/* Right Div - Image */}
            <div className="data-image">
                <img src={dataPattern} alt="Data Visualization" />
            </div>
        </section>
    );
};

export default DataAnalytics;
